import script from "./SmallImageUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./SmallImageUploader.vue?vue&type=script&setup=true&lang=js"

import "./SmallImageUploader.vue?vue&type=style&index=0&id=912364be&lang=scss&scoped=true"

import exportComponent from "E:\\东智商户端源码\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-912364be"]])

export default __exports__